import {create} from 'zustand';
import {ExternalServiceStore} from './types';

export const useExternalServiceStore = create<ExternalServiceStore>(set => ({
	urls: {},
	setUrl: (key, value) =>
		set(state => ({
			urls: {...state.urls, [key]: value},
		})),
	resetUrl: key =>
		set(state => {
			const {[key]: _, ...rest} = state.urls;
			return {urls: rest};
		}),
}));
